<template>
  <div id="new-negotiation">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="2" class="pa-5" :loading="loading">
      <div class="pt-1 pb-4">
        <h1>Transferir dados de Transbordo</h1>
      </div>
      <v-card-text class="pa-0 ma-0">
        <v-row class="py-5 align-center">
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="thisTranshipmentId"
              label="Transbordo atual:"
              :items="transhipments"
              item-text="name"
              item-value="id"
              @change="handleTranshipmentChange"
              class="auto-complete"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              :disabled="thisTranshipmentId === null"
              v-model="newTranshipmentId"
              label="Transferir para:"
              :items="unselectedTranshipments"
              item-text="name"
              item-value="id"
              @change="handleTranshipmentToTransferChange"
              class="auto-complete"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
              v-model="shouldKeepTranshipmentValue"
              label="Recalcular preço do transbordo"
              hide-details
              class="pb-2"
              :disabled="shouldDisableKeepPrice"
            />
          </v-col>
        </v-row>

        <v-tabs v-model="selectedTab">
          <v-tab :disabled="!hasSelectedTranshipment"> Paradas </v-tab>
          <v-tab :disabled="!hasSelectedTranshipment"> Entregadores </v-tab>
        </v-tabs>
        <v-tabs-items v-if="hasSelectedTranshipment" v-model="selectedTab">
          <v-tab-item>
            <transhipment-transfer-stops-tab @transferStops="handleTransferStops" class="mt-4" />
          </v-tab-item>

          <v-tab-item>
            <transhipment-transfer-deliverer-tab @feedbackReceived="handleFeedback" class="mt-4" />
          </v-tab-item>
        </v-tabs-items>

        <div v-if="!hasSelectedTranshipment" class="d-flex align-center py-8">
          <v-icon color="#909090" size="20" class="px-2"> mdi-information-outline </v-icon>
          <span class="" style="color: #909090"
            >Selecione um <strong>transbordo</strong> para visualizar as paradas/entregadores</span
          >
        </div>
      </v-card-text>
    </v-card>
    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />

    <TranshipmentTransfer
      :open="transferStops"
      :newTranshipmentId="newTranshipmentId"
      :selectedCheckbox="selectedCheckbox"
      :shouldKeepTranshipmentValue="shouldKeepTranshipmentValue"
      @closeTranshipmentTransfer="closeTranshipmentTransfer"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';
import copyToClipboard from '../../../utils/copyToClipboard';
import TranshipmentTransfer from '../../../components/TransferHierarchy.vue';
import TranshipmentTransferDelivererTab from '@/components/Transhipment/TranshipmentTransferDelivererTab';
import TranshipmentTransferStopsTab from '@/components/Transhipment/TranshipmentTransferStopsTab';
import { TranshipmentTransferHandler } from '@/store/modules/transhipmentTransfer';

import maskCPF from '../../../utils/maskCPF';
import maskCNPJ from '../../../utils/maskCNPJ';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
import maskWeight from '../../../utils/maskWeight';

export default {
  name: 'TranshipmentTransferData',
  components: {
    BreadCrumb,
    MessagesError,
    TranshipmentTransfer,
    TranshipmentTransferDelivererTab,
    TranshipmentTransferStopsTab
  },
  data: () => ({
    shouldKeepTranshipmentValue: true,
    selectedTab: 0,
    isTransferDeliverersLoading: false,
    errors: [],
    errorsType: 'error',
    error500: null,
    directDelivererId: null,
    thisTranshipmentId: null,
    newTranshipmentId: null,
    nfeNumber: null,
    loading: false,
    loadingStops: false,
    delivery: [],
    selectedCheckbox: [],
    textSearchDelivery: '',
    deliveries: [],
    transhipments: [],
    transferStops: false,
    filtersLoading: false,
    nodes: []
  }),

  computed: {
    ...mapGetters('CouriersStore', ['getSummaryData']),
    ...mapState('TranshipmentStore', ['paginateTransfer']),
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '/start'
        },
        {
          text: 'Transbordo',
          disabled: false,
          to: '/transhipment'
        },
        {
          text: 'Transferir dados',
          disabled: true,
          to: ''
        }
      ];
    },

    unselectedTranshipments() {
      return this.transhipments.filter((item) => {
        return item.id !== this.thisTranshipmentId;
      });
    },
    hasSelectedTranshipment() {
      return this.thisTranshipmentId !== null;
    },
    shouldDisableKeepPrice() {
      return this.selectedTab === 1 || !this.hasSelectedTranshipment;
    }
  },
  mounted() {
    this.fetchSummaryDataTranshipment();
    this.fetchAllSummaryData();
  },
  methods: {
    ...mapActions('TranshipmentStore', [
      'fetchTranshipment',
      'fetchAllTranshipment',
      'fetchTranshipmentBetweenDeliverers',
      'fetchTranshipmentBetweenStops',
      'fetchTranshipmentBetweenDeliveriesPending',
      'fetchTranshipmentBetweenNfes',
      'getSummaryDataTranshipment',
      'setTransferDataDeliverers'
    ]),
    ...mapActions('CouriersStore', ['fetchSummaryData']),
    ...mapMutations('TranshipmentStore', ['setPageNumberTransfer', 'setFiltersNfeNumberId']),
    copy(str) {
      copyToClipboard(str);
    },
    transformDate(date) {
      return maskData(date);
    },
    transformWeight(weight) {
      return maskWeight(weight);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },

    async fetchAllSummaryData() {
      this.loading = true;
      try {
        await this.fetchSummaryData();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async fetchSummaryDataTranshipment() {
      this.loading = true;
      try {
        this.transhipments = await this.getSummaryDataTranshipment();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    closeTranshipmentTransfer(hasChange, message) {
      this.transferStops = false;
      if (hasChange) this.fetchSummaryDataTranshipment();
      if (message) {
        this.thisTranshipmentId = null;
        this.newTranshipmentId = null;
        this.selectedCheckbox = [];
        this.deliveries = [];
        this.nodes = [];
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.handleTranshipmentToTransferChange(null);
      }
    },

    handleFeedback(feedback) {
      const { errors, errorsType } = feedback;
      this.errors = errors;
      this.errorsType = errorsType;
    },

    handleTransferStops(stopsToTransfer) {
      this.selectedCheckbox = stopsToTransfer;
      this.transferStops = true;
    },

    handleTranshipmentChange(transhipmentId) {
      TranshipmentTransferHandler.setSelectedTranshipmentId(this, transhipmentId);
    },

    handleTranshipmentToTransferChange(transhipmentToTransferId) {
      TranshipmentTransferHandler.setSelectedTranshipmentToTransferId(this, transhipmentToTransferId);
    }
  }
};
</script>

<style lang="scss">
#new-negotiation {
  .mt-10-topo {
    position: relative;
    top: -18px;
    margin: 0;
    padding: 0;
  }
}
.p-treetable {
  max-width: 100%;
  overflow: auto;
}
</style>
